var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-with-tabs',{ref:"userModal",attrs:{"formKey":_vm.formKey,"formAction":_vm.formAction,"user":_vm.selectedUser,"venues":_vm.venues,"roles":_vm.roles,"platform":"venue"},on:{"success":_vm.onSubmitSuccess,"close":_vm.reset}})
}
var staticRenderFns = []

export { render, staticRenderFns }